import http from '../util/request.js'

export const cashList = (params) =>{
	return http({
		url:'/apistore/cash/list',
		data:params,
		method:'get'
	})
}

export const cashAdd = (params) =>{
	return http({
		url:'/apistore/cash/add',
		data:params,
		method:'post'
	})
}
